import { Color } from '@/constants/color';
import Badge from '@/ui/components/Badge';

// Per-queue color so the routing key is scannable at a glance and consistent
// across panels. Unknown queues fall back to slate so any new queue name still
// renders with high contrast rather than silently blank.
const QUEUE_COLOR: Record<string, Color> = {
  celery: Color.SKY,
  urgent: Color.RED,
  low: Color.INDIGO,
  'long-heavy': Color.AMBER,
  'long-lite': Color.EMERALD,
  'heavy-sync-worker': Color.ORANGE
};

// Mirrors the backend's KNOWN_QUEUES. Derived from the colour map so a queue
// can't be filterable but uncoloured, or vice versa.
export const QUEUE_NAMES = Object.keys(QUEUE_COLOR);

const queueColor = (queue: string | null): Color => (queue && QUEUE_COLOR[queue]) || Color.SLATE;

const QueueBadge = ({ queue }: { queue: string | null }) => (
  <Badge color={queueColor(queue)} className="font-mono normal-case">
    {queue ?? '—'}
  </Badge>
);

export default QueueBadge;
